export enum SweepCanvasReactFlowEdgeDataType {
  SIMPLE = 'simple',
  CIRCLE = 'circle',
  DASHED_CIRCLE = 'dashedcircle',
  REMOVABLE = 'removable',
}
